import { Component } from '@angular/core';
import { DynamicPlacemarkService } from 'src/app/services/dynamic-placemark.service';

import { DynamicPlacemarkTableComponent } from './dynamic-placemark-table/dynamic-placemark-table.component';
import { DynamicPlacemarkPieComponent } from './dynamic-placemark-pie/dynamic-placemark-pie.component';

@Component({
    selector: 'ins-dynamic-placemark',
    templateUrl: './dynamic-placemark.component.html',
    styleUrls: ['./dynamic-placemark.component.scss'],
    imports: [DynamicPlacemarkTableComponent, DynamicPlacemarkPieComponent]
})
export class DynamicPlacemarkComponent {
  public dynamicPlacemarks: any[] = [];
  public dynamicPMOnHover: any;

  constructor(private dynamicPlacemarkService: DynamicPlacemarkService) {
    this.dynamicPlacemarkService.dynamicPlacemarksChange.subscribe( (dynamicPlacemarks: any[]) => {
      this.dynamicPlacemarks = dynamicPlacemarks;
    });

    this.dynamicPlacemarkService.dynamicPMOnHoverChange.subscribe( (dynamicPMOnHover: any[]) => {
      this.dynamicPMOnHover = dynamicPMOnHover;
    });
  }

}
